module.exports = __webpack_public_path__ + "static/blockchain-0d00735c8489202399a5dce5043f68da.webp";